module.exports = __webpack_public_path__ + "static/img/success@2x.d717af17.png";